import React from "react";
import personDoc from "../assets/images/person_doc.png";
import bellIcon from "../assets/images/bell_orange.png";
import phoneIcon from "../assets/images/phone.png";
import whatsappIcon from "../assets/images/whatsapp.png";
import "./WhatHappensNext.css";

const WhatHappensNext = () => {
    const handleCall = () => {
        window.open("tel:+917949106799", "_self");
    };

    const handleWhatsApp = () => {
        window.open("https://wa.me/918928899744", "_blank");
    };

    return (
        <div className="section-box">
            <div className="section-next">
                <h3 className="section-title">What Happens Next?</h3>
                <div className="icon-text-row">
                    <img src={personDoc} alt="Doctor" className="small-icon" />
                    <p className="paragraph">
                        Our team will contact you shortly to confirm the details and schedule your next session.
                    </p>
                </div>

                <div className="icon-text-row">
                    <img src={bellIcon} alt="Reminder" className="small-icon" />
                    <p className="paragraph">
                        You'll receive reminders for your sessions, and you can track your progress via our app.
                    </p>
                </div>
            </div>

            <p className="assistance-text">Need assistance? Contact us at</p>

            <div className="contact-box" onClick={handleCall}>
                <img src={phoneIcon} alt="Call" className="contact-icon-sm" />
                <span className="contact-text">
                    Call Us Now<br />+917949106799
                </span>
            </div>

            <div className="contact-box" onClick={handleWhatsApp}>
                <img src={whatsappIcon} alt="WhatsApp" className="contact-icon" />
                <span className="contact-text">
                    WhatsApp Us<br />+918928899744
                </span>
            </div>
        </div>
    );
};

export default WhatHappensNext;
